<script>
    import {
        NotificationModal,
        RichTextEditor,
    } from "../../Components/Common/index.svelte";
    import { apiMethods } from "../../Services/index.svelte";
    import { NoteTypes } from "../../Utils/utilConstants.svelte";
    import { showError, showInfo } from "../../Utils/utilFunctions.svelte";

    export let isModalOpen = true,
        encounter = {},
        closeModal = () => {},
        confirmAction = () => {};

    $: if (isModalOpen)
        setTimeout(() => {
            noteInputRef?.focus();
        }, 200);

    let currentNote = { visibleToDoctors: true },
        noteInputRef,
        isConfirming = false;

    const updateNotes = async () => {
        isConfirming = true;

        await apiMethods.postMethod
            .createNote({
                relTo: NoteTypes.PatientEncounter,
                relId: encounter.id,
                content: currentNote.content,
                visibleToDoctors: currentNote.visibleToDoctors,
            })
            .then((res) => {
                if (!res || res.error)
                    showError(
                        res.error ??
                            "Failed to add notes to selected encounter, please refresh the page and try again and contact support if the issue persists.",
                    );
                else {
                    showInfo("Note Created");
                    confirmAction();
                }
            })
            .catch((err) => showError(err));

        isConfirming = false;
        closeModal();
    };
</script>

{#if isModalOpen}
    <NotificationModal
        {isModalOpen}
        title="Add Note"
        cancelText="Discard"
        {isConfirming}
        {closeModal}
        closeModalFunction={closeModal}
        showConfirmBtn={false}
        btnOptions={[
            {
                text: "Add",
                function: () => updateNotes(),
                loading: isConfirming || !currentNote.content,
            },
        ]}
        modalMaxWidth="max-w-6xl"
    >
        <div class="flex flex-col gap-y-4 flex-1">
            <div class="flex flex-1 w-full gap-x-2">
                <p class="title">Content:</p>
                <!-- <textarea
                    class="textarea textarea-bordered w-full flex-1"
                    rows="6"
                    autocomplete="off"
                    bind:value={currentNote.content}
                    bind:this={noteInputRef}
                /> -->
                <div class="content">
                    <RichTextEditor bind:content={currentNote.content} />
                </div>
            </div>

            <div class="flex flex-1 w-full gap-x-2">
                <p class="title">Visible to Doctors:</p>
                 <div class="content">
                    <input
                        type="checkbox"
                        class="toggle toggle-secondary"
                        bind:checked={currentNote.visibleToDoctors}
                    />
                </div>
                
            </div>
        </div>
    </NotificationModal>
{/if}

<style>
  .title {
    width: 200px;
  }
  .content {
    width: calc(100% - 200px);
  }
</style>